import { defineStore } from "pinia";

export const useEquipmentStore = defineStore({
  id: "evaluation",
  state: () => ({}),
  getters: {},
  actions: {}
});
